import EmailConfirmation from './EmailConfirmation.container'

export default EmailConfirmation
